import { GetItineraries, GetDates, SendSignUpRequest, GetShipIntro, GetPastDers } from './DerSignUpModule.api';
import { Module, ActionTree, MutationTree, Store } from 'vuex';
import { RootState } from '@/store/types';
import { registerSubModule } from '@/utils/vueUtils';
import { getDropdownProps, SecondStepModel } from './SecondStep/SecondStep.types';
import { DerSubscribeBlockViewModel } from './DerSignUpModule.types';
import SelectItem from '@/common/interfaces/SelectItem';
import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';
import { TitleTextHeaderBlockViewModel } from '../TitleTextHeaderModule/TitleTextHeaderModule.types';
import { RelatedItemsModuleViewModel } from '../RelatedItemsModule/RelatedItemsModule.types';
import { TransactionId } from '@/plugins/utm/SegmentElement';

export interface DerSignUpModuleState extends TransactionId {
  Choise: string;
  Itinararies: SelectItem[];
  Dates: SelectItem[];
  ShowThankYouMessage: boolean;
  ShipIntro: TitleTextHeaderBlockViewModel;
  PastDers: RelatedItemsModuleViewModel;
  ItineraryLink: string;
  IsNotShowSecondFormPart?: boolean;
  PrePopulateDestinationId?: number;
  PrePopulateItineraryId?: number;
  PrePopulateDepartureNumber?: number;
}

export const GET_ITINERARIES_REQUEST = 'GET_ITINERARIES_REQUEST';
export const GET_ITINERARIES_SUCCESS = 'GET_ITINERARIES_SUCCESS';
export const GET_ITINERARIES_ERROR = 'GET_ITINERARIES_ERROR';

export const GET_DATES_REQUEST = 'GET_DATES_REQUEST';
export const GET_DATES_SUCCESS = 'GET_DATES_SUCCESS';
export const GET_DATES_ERROR = 'GET_DATES_ERROR';

export const GET_SHIP_INTRO = 'GET_SHIP_INTRO';
export const GET_PAST_DERS = 'GET_PAST_DERS';

export const SET_SHIP_INTRO = 'SET_SHIP_INTRO';
export const SET_PAST_DERS = 'SET_PAST_DERS';

export const SUBMIT_FORM = 'SUBMIT_FORM';
export const SET_CHOISE = 'SET_CHOISE';
export const CLEAR_ITIN = 'CLEAR_ITIN';
export const CLEAR_DATES = 'CLEAR_DATES';
export const SET_ITIN_LINK = 'SET_ITIN_LINK';

export const SHOW_THANK_YOU_MESSAGE = 'SHOW_THANK_YOU_MESSAGE';
export const SET_TRANSACTION_ID = 'SET_TRANSACTION_ID';

const actions: ActionTree<DerSignUpModuleState, RootState> = {
  async [SUBMIT_FORM]({ dispatch, commit }, model: SecondStepModel) {
    try {
      const result = await SendSignUpRequest(model, true);
      commit(SET_ITIN_LINK, result.ItineraryLink)
      commit(SET_TRANSACTION_ID, result.transaction_id)
      await dispatch(GET_SHIP_INTRO, model.DepartureId);
      commit(SHOW_THANK_YOU_MESSAGE);
      
      await dispatch(GET_PAST_DERS, model);
    } catch (e) {
      console.error(e);
    }
  },
  async [GET_ITINERARIES_REQUEST]({ commit }, payload: getDropdownProps) {
    const { destinationId, showloading = true } = payload;
    try {
      commit(CLEAR_ITIN);
      commit(CLEAR_DATES);
      const result = await GetItineraries(destinationId, showloading);
      if (result) {
        commit(GET_ITINERARIES_SUCCESS, result);
      } else {
        commit(GET_ITINERARIES_ERROR, "Didn't find any Itineraries.");
      }
    } catch (error) {
      commit(GET_ITINERARIES_ERROR, error);
    }
  },
  async [GET_DATES_REQUEST]({ commit }, payload: getDropdownProps) {
    const { itineraryId, showloading = true } = payload;
    try {
      commit(CLEAR_DATES);
      const result = await GetDates(itineraryId, showloading);
      if (result) {
        commit(GET_DATES_SUCCESS, result);
      } else {
        commit(GET_DATES_ERROR, "Didn't find any dates.");
      }
    } catch (error) {
      commit(GET_DATES_ERROR, error);
    }
  },

  async [GET_SHIP_INTRO]({ commit }, departureId: string) {
    try {
      const result = await GetShipIntro(departureId, true);
      commit(SET_SHIP_INTRO, result);
    } catch (e) {
      console.error(e)
    }
  },
  async [GET_PAST_DERS]({ commit }, model: SecondStepModel) {
    try {
      const result = await GetPastDers(model.DepartureId, model.DestinationId, true);
      commit(SET_PAST_DERS, result);
    } catch (e) {
      console.error(e);
    }
  },
};

const mutations: MutationTree<DerSignUpModuleState> = {
  [SHOW_THANK_YOU_MESSAGE](state) {
    state.ShowThankYouMessage = true;
    if (!state.IsNotShowSecondFormPart) {
      Vue.nextTick(() => VueScrollTo.scrollTo('#app'));
    } else {
      Vue.nextTick(() => VueScrollTo.scrollTo('#der-signup-root'));
    }
  },
  [SET_TRANSACTION_ID](state, id: number) {
    state.transaction_id = +id;
  },
  [SET_CHOISE](state, payload: string) {
    state.Choise = payload;
  },
  [GET_ITINERARIES_ERROR](state, message) {
    //console.log(message);
  },
  [GET_DATES_ERROR](state, message) {
    //console.log(message);
  },
  [GET_ITINERARIES_SUCCESS](state, payload: SelectItem[]) {
    state.Itinararies = payload;
  },
  [GET_DATES_SUCCESS](state, payload: SelectItem[]) {
    state.Dates = payload;
  },
  [CLEAR_DATES](state) {
    state.Dates = [];
  },
  [CLEAR_ITIN](state) {
    state.Itinararies = [];
  },
  [SET_SHIP_INTRO](state, payload: TitleTextHeaderBlockViewModel) {
    state.ShipIntro = payload;
  },
  [SET_PAST_DERS](state, payload: RelatedItemsModuleViewModel) {
    state.PastDers = payload;
  },
  [SET_ITIN_LINK](state, payload: string) {
    state.ItineraryLink = payload
  }
};

const registerModule = registerSubModule<DerSignUpModuleState, DerSubscribeBlockViewModel>(
  (data: DerSubscribeBlockViewModel) => {
    const { IsNotShowSecondFormPart, PrePopulateDestinationId, PrePopulateItineraryId, PrePopulateDepartureNumber } = data;
    return {
      namespaced: true,
      state: {
        Choise: '',
        Itinararies: [],
        Dates: [],
        ShowThankYouMessage: false,
        ShipIntro: {},
        PastDers: {},
        ItineraryLink: '',
        IsNotShowSecondFormPart,
        PrePopulateDestinationId,
        PrePopulateItineraryId,
        PrePopulateDepartureNumber,
        transaction_id: 0,
      },
      actions,
      mutations,
    } as Module<DerSignUpModuleState, RootState>;
  },
  'DerSignUpModule'
);

export default (store: Store<RootState>, data: DerSubscribeBlockViewModel) => {
  return registerModule(store, data)
}
